'use client';

import { debounce } from 'radash';
import { useState, useLayoutEffect, useEffect, useCallback } from 'react';

import type { RefObject } from 'react';

export const useElementOverflow = (elementRef: RefObject<HTMLElement | null> | null, pause?: boolean) => {
  const [isOverflowing, setIsOverflowing] = useState(false);

  const updateOverflow = useCallback(() => {
    if (elementRef?.current) {
      setIsOverflowing(elementRef.current.scrollWidth > elementRef.current.clientWidth);
    }
  }, [elementRef]);

  useLayoutEffect(() => {
    if (pause) {
      return;
    }
    updateOverflow();
  }, [elementRef, pause, updateOverflow]);

  useEffect(() => {
    const onResize = debounce({ delay: 100 }, () => {
      updateOverflow();
    });
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [elementRef, updateOverflow]);

  return isOverflowing;
};
